import { UNIFIED_DOMAIN_LOCALES } from '@raisin/cp-utils';

export const getUpdatedExternalLink = (link: string | undefined, locale: string | undefined) => {
  if (link?.startsWith('/') && UNIFIED_DOMAIN_LOCALES.includes(locale as string)) {
    return `/${locale}${link}`;
  }

  return link;
};

export const isCallalikeSubtype = (productType: string, dailySettlement: boolean | undefined) =>
  ['NOTICE', 'OVERNIGHT'].includes(productType) && dailySettlement === false;

export const extractHrefs = (menus: any): string[] => {
  const hrefs: string[] = [];

  const collectHrefs = (items: any[]) => {
    items.forEach((item) => {
      if (item.href) {
        hrefs.push(item.href);
      }
      if (item.subMenus) {
        Object.values(item.subMenus).forEach((subMenu) => {
          if (Array.isArray(subMenu)) {
            collectHrefs(subMenu);
          }
        });
      }
    });
  };

  collectHrefs(menus.navItems);

  const logoHref = menus?.logoItems?.[0]?.href;
  if (logoHref) {
    hrefs.push(logoHref);
  }

  return hrefs.filter((href) => !href.startsWith('http'));
};

export const removeLocalePrefix = (url: string, locale: string) => {
  const cleanedUrl = url
    .replace(new RegExp(`/${locale.toLowerCase()}/`, 'g'), '/')
    .replace(/\/$/, '');
  return cleanedUrl === '' ? '/' : cleanedUrl;
};
